// @flow

import authApiService from './auth-api-service';
import { FileType } from '../types/file';

export class ConsentFormService {
  getUnsigned(providerAddressId: Number): Promise<Blob> {
    return authApiService.get(
      `/provider-addresses/${providerAddressId}/filled_form`,
      { responseType: 'blob' }
    )
      .then((response) => {
        return new Blob([response]);
      });
  }

  getFileInfo(identifier: string): Promise<FileType> {
    return Promise.resolve({
      mime_type: 'application/pdf',
      file_name: `consent_form_${identifier}`
    });
  }

  getSigned(requestId: Number): Promise<Blob> {
    return authApiService.get(
      `/information_requests/${requestId}/consent_form`,
      { responseType: 'blob' }
    ).then((response) => {
      return new Blob([response]);
    });
  }
}

export default new ConsentFormService();



// WEBPACK FOOTER //
// ./src/services/consent-form-service.js